import React, { Component } from "react";
import PurchaseMessage from "./PurchaseMessage";
import CoinDetails from "./CoinDetails";
import "./css/CoinCharts.css";

class CoinCharts extends Component {
    render() {
        return (
            <>
                <div className="message-wrapper">
                    <div className="container">
                        <PurchaseMessage></PurchaseMessage>
                    </div>
                    <CoinDetails />
                </div>
            </>
        );
    }
}

export default CoinCharts;